import { styled } from "styled-components";
import { Page } from "../../../components/layout/page/page.component";
import { Project } from "../../dashboard/components/project.component";
import { Spacer } from "../../../components/ui/spacer/spacer.component";
import { FloatingActionButton } from "../../../components/ui/fab/fab.component";
import { useNavigate } from "react-router-dom";
import { MdAdd } from "react-icons/md";
import { colors } from "../../../theme/colors";
import { useEffect, useState } from "react";
import { axios } from "../../../api/axios";
import { handleResponse } from "../../../utils/functions/http/handleResponse";
import { Row } from "../../../components/ui/grid/row.component";
import { FilmProfile } from "../../../models/film-profile.model";
import { Pill } from "../../../components/ui/pill/pill.component";

const filters = [
  {
    label: "draft",
    filterFn: (project: FilmProfile) => project.status === "draft",
  },
  {
    label: "published",
    filterFn: (project: FilmProfile) =>
      project.status === "published" && !project.is_distributed,
  },
  {
    label: "distributing",
    filterFn: (project: FilmProfile) =>
      project.status === "published" && project.is_distributed,
  },
];

export const AllSeries = () => {
  const navigate = useNavigate();
  const [series, setSeries] = useState<any[]>([]);

  const [activeFilterIndex, setActiveFilterIndex] = useState<number | null>(
    null
  );

  useEffect(() => {
    axios
      .get("/client/get/series/me")
      .then((resp) => {
        setSeries(resp.data);
      })
      .catch(handleResponse);
  }, []);

  return (
    <Page>
      <Spacer size={75} direction="bottom" />
      <FilterByLabel>Filter By</FilterByLabel>
      <Spacer direction="bottom" size={5} />
      <OptionsRow>
        <Row style={{ gap: "0.5rem", zIndex: 2 }}>
          {filters.map((filter, index) => (
            <Pill
              style={{
                backgroundColor:
                  activeFilterIndex === index
                    ? colors.primary.hex
                    : colors.white.hex,
                color:
                  activeFilterIndex === index
                    ? colors.white.hex
                    : colors.black.hex,
              }}
              onClick={() => {
                setActiveFilterIndex(
                  activeFilterIndex === index ? null : index
                );
              }}
            >
              {filter.label}
            </Pill>
          ))}
        </Row>
      </OptionsRow>
      <Spacer direction="bottom" size={15} />
      <Main>
        {series
          .filter((film) =>
            activeFilterIndex === null
              ? true
              : filters[activeFilterIndex].filterFn(film)
          )
          .map((film) => (
            <Project key={film.id} project={film} kind="series" />
          ))}
        {series.length === 0 ? (
          <NoResultsText>No series created!</NoResultsText>
        ) : null}
      </Main>
      <FloatingActionButton
        onClick={() => {
          navigate("/s/create");
        }}
      >
        <MdAdd size={25} color={colors.white.hex} />
        Create Series
      </FloatingActionButton>
    </Page>
  );
};

const Main = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 27rem), 37.5rem));
  justify-content: start;
  gap: 2rem;
  width: 100%;
`;

const NoResultsText = styled.h3`
  grid-column: 1 / -1;
  font-size: 1.5rem;
  text-align: center;
`;

const FilterByLabel = styled.label`
  font-size: 1.4rem;
  font-weight: 500;
`;

const OptionsRow = styled(Row)`
  width: 100%;
  justify-content: space-between;
  padding-right: 2rem;

  @media only screen and (max-width: 23.4375em) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 1rem;
  }
`;
